import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import {Popover} from "material-ui";

class StevedoringPopover extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openPopover: false,
            anchorElPopover: {},
        };

        this.handleRequestClosePopover = this.handleRequestClosePopover.bind(this);
        this.handleClickPopover = this.handleClickPopover.bind(this);
    }

    handleClickPopover(event) {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            openPopover: true,
            anchorElPopover: event.currentTarget,
        });
    };

    handleRequestClosePopover() {
        this.setState({
            openPopover: false,
        });
    };

    render() {
        const { openPopover, anchorElPopover } = this.state;
        const { serviceProvider } = this.props;

        return (
            <Fragment>
                {
                    serviceProvider.activities.map((activity, index) => {
                        return (
                            <div key={`activity_${index}`}>
                                <span>{activity}</span><br/>
                            </div>
                        );
                    })
                }

                <div className="icon info-icon">
                    <Popover
                        open={openPopover}
                        anchorEl={anchorElPopover}
                        anchorOrigin={{"horizontal":"middle","vertical":"center"}}
                        targetOrigin={{"horizontal":"middle","vertical":"center"}}
                        onRequestClose={this.handleRequestClosePopover}
                    >
                        <div className="paper-block stevedoring-popover">
                            <div className='title'>{serviceProvider.activities.join(',')}</div>
                            <div className="limitations">
                                {
                                    serviceProvider.limitations.map((limitation, limitationIndex) => {
                                        return (
                                            <div key={`limitation_stevedoring_${limitationIndex}`}>
                                                <span className='limitation__counter'>{`Limitation: ${limitationIndex + 1}`}</span>
                                                <div className="limitation">
                                                    Berth <span style={{ wordBreak: 'break-all', position: 'inherit' }}>{limitation.berth}</span>
                                                </div>
                                                <div className="limitation">
                                                    Max draft <span>{limitation.maxDraught} m</span>
                                                </div>
                                                <div className="limitation">
                                                    Max beam <span>{limitation.maxBeam} m</span>
                                                </div>
                                                <div className="limitation">
                                                    Max LOA <span>{limitation.maxLOA} m</span>
                                                </div>
                                                <div className="limitation">
                                                    Max DWT <span>{limitation.maxDWT} m</span>
                                                </div>
                                                <div className="limitation">
                                                    Channel depth <span>{limitation.channelDepth} m</span>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </Popover>
                    <IconButton
                        iconStyle={{  color: '#CBCBCB' }}
                        onClick={this.handleClickPopover}>
                        <InfoIcon
                            style={{ color: '#CBCBCB' }}
                        />
                    </IconButton>
                </div>
            </Fragment>
        );
    }
}

StevedoringPopover.propTypes = {

};

StevedoringPopover.defaultProps = {

};

export default StevedoringPopover;



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/StevedoringPopover.jsx